export const buyers = [
  { name: 'Valentina', country: 'Argentina' },
  { name: 'Mateo', country: 'Mexico' },
  { name: 'Camila', country: 'Colombia' },
  { name: 'Javier', country: 'Spain' },
  { name: 'Sofía', country: 'Chile' },
  { name: 'Andrés', country: 'Peru' },
  { name: 'Isabella', country: 'Uruguay' },
  { name: 'Diego', country: 'Ecuador' },
  { name: 'Mariana', country: 'Costa Rica' },
  { name: 'Alejandro', country: 'Venezuela' },
  { name: 'Lucía', country: 'Paraguay' },
  { name: 'Gabriel', country: 'Dominican Republic' },
  { name: 'Daniela', country: 'Guatemala' },
  { name: 'Sebastián', country: 'Bolivia' },
  { name: 'Paula', country: 'Panama' },
  { name: 'Fernando', country: 'Puerto Rico' },
];
